import { COUNTRIES } from './collections.js';

// Legacy organisation profiles stored country as free text. These aliases map
// the common spellings onto the shared COUNTRIES list so admins rarely have to
// reselect by hand.
const COUNTRY_ALIASES: Readonly<Record<string, string>> = {
  uk: 'United Kingdom',
  'u.k.': 'United Kingdom',
  gb: 'United Kingdom',
  'great britain': 'United Kingdom',
  britain: 'United Kingdom',
  england: 'United Kingdom',
  scotland: 'United Kingdom',
  wales: 'United Kingdom',
  'northern ireland': 'United Kingdom',
  usa: 'United States',
  us: 'United States',
  'u.s.': 'United States',
  'u.s.a.': 'United States',
  'united states of america': 'United States',
  america: 'United States',
  eire: 'Ireland',
  'republic of ireland': 'Ireland',
  uae: 'United Arab Emirates',
  holland: 'Netherlands',
};

const BY_LOWER = new Map(COUNTRIES.map((c) => [c.toLowerCase(), c]));

/**
 * Map a free-text country onto a COUNTRIES entry: exact match, then
 * case-insensitive, then a small alias table. Returns null when nothing fits.
 */
export function normaliseCountry(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed === '') return null;
  if (COUNTRIES.includes(trimmed)) return trimmed;
  const lower = trimmed.toLowerCase().replace(/\s+/g, ' ');
  return BY_LOWER.get(lower) ?? COUNTRY_ALIASES[lower] ?? null;
}
